<template>
  <d-container fluid class="main-content-container align-items-center justify-content-center">
    <d-col v-if="!d_showQueryError" cols="12">
      <d-row v-if="d_request.loading && !d_request.error" class="justify-content-center">
        <d-col class="col-auto">
          <loader :loading="d_request.loading" />
        </d-col>
      </d-row>

      <div v-else-if="d_request.error">
        {{ $t('error.general') }}: {{ d_request.errors.get('message') }}
      </div>

      <d-row v-else class="justify-content-center">
        <d-col class="border bg-white p-4 col-10 col-md-8 col-xl-6">
          <d-row class="justify-content-between">
            <d-col cols="12">
              <h3 class="border-bottom border-dark pb-2 mb-4">
                {{ $t('consent.title') }}
              </h3>

              <i18n class="mb-2" path="consent.request.header" tag="p">
                <a :href="d_response.client_url" target="_blank">
                  {{ d_response.client_name }}
                </a>
              </i18n>

              <auth-consent-form @submit="submitConsent" :request="d_submitRequest" :scopes="d_response.scopes" />
            </d-col>
          </d-row>
        </d-col>
      </d-row>
    </d-col>

    <d-col v-else md="8" class="text-center">
      {{ $t('consent.invalid_token') }}
    </d-col>
  </d-container>
</template>

<script>
import RedirectRequest from '@/library/RedirectRequest';
import AuthConsentForm from '@/components/auth/ConsentForm';

export default {
  name: 'auth-consent',
  components: {AuthConsentForm},
  data () {
    return {
      d_request: new RedirectRequest(),
      d_submitRequest: new RedirectRequest(),
      d_response: {},
      d_showQueryError: false,
      d_consentUrl: null,
    };
  },
  created () {
    if (!(this.$route.query.hasOwnProperty('consent_challenge') && this.$route.query.consent_challenge)) {
      this.d_showQueryError = true;

      return;
    }

    this.d_consentUrl = `consent?consent_challenge=${this.$route.query.consent_challenge}`;

    this.d_request.get(this.d_consentUrl)
      .then(response => {
        this.d_response = response;
      });
  },
  methods: {
    submitConsent (type) {
      this.d_submitRequest[type](this.d_consentUrl);
    },
  },
}
</script>
